import { Cart as CartModule } from '../../../Cart/Cart';
import { Header } from '../../../Cart/components/Header';
import { Items as CartItems } from '../../../Cart/components/Items';
import { Divider } from '../../../components/Divider';
import { OrderFieldsFragment, OrderStatusEnum } from '../../graphql';
import { castOrderItem } from '../../utils/castOrderItem';

export type ItemsProps = React.HTMLAttributes<HTMLDivElement> &
	Pick<OrderFieldsFragment, 'items' | 'refunds'> & {
		status?: OrderStatusEnum;
	};

export const Items: React.FC<ItemsProps> = ({ items, refunds, status }) => {
	const itemsNotRefunded = items.filter(item =>
		refunds.length === 0
			? true
			: refunds.some(
					refund =>
						!refund.items.some(
							refundItem => refundItem.id === item.id
						)
			  )
	);

	return (
		<div className="order-items">
			<CartModule>
				<Header />

				<Divider />

				<CartItems
					items={itemsNotRefunded.map(castOrderItem)}
					checkIsItemEditable={() => false}
					divider={<Divider my={2} borderColor="light" />}
					status={status}
				/>
			</CartModule>
		</div>
	);
};
